module.exports = __webpack_public_path__ + "static/shape2-5eeb3542f824d3921c2651188806ebc9.svg";